import { ApolloClient, InMemoryCache, HttpLink, ApolloLink, Observable } from '@apollo/client/core';

const ACCESS_TOKEN_KEY = 'bms_access_token';

const httpLink = new HttpLink({
  uri: `${import.meta.env.VITE_API_TARGET || 'http://localhost:4000'}/graphql`,
  credentials: 'include',
});

// Attach Bearer token to every request — plain ApolloLink (v4 compatible)
const authLink = new ApolloLink((operation, forward) => {
  const token = localStorage.getItem(ACCESS_TOKEN_KEY);
  operation.setContext(({ headers = {} }: { headers: Record<string, string> }) => ({
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  }));
  return forward(operation);
});

// On UNAUTHENTICATED or TOKEN_EXPIRED GraphQL error: clear tokens + hard-redirect to /login
const SESSION_ENDING_CODES = new Set(['UNAUTHENTICATED', 'TOKEN_EXPIRED']);
const errorLink = new ApolloLink((operation, forward) => {
  return new Observable(observer => {
    const sub = forward(operation).subscribe({
      next: response => {
        const errors = response.errors;
        if (errors?.some(e => SESSION_ENDING_CODES.has(e.extensions?.code as string))) {
          localStorage.removeItem(ACCESS_TOKEN_KEY);
          localStorage.removeItem('bms_refresh_token');
          localStorage.removeItem('bms_current_user');
          // clearStore is async but we fire-and-forget here — hard redirect follows immediately
          apolloClient.clearStore().finally(() => { window.location.href = '/login'; });
          return;
        }
        observer.next(response);
      },
      error: observer.error.bind(observer),
      complete: observer.complete.bind(observer),
    });
    return () => sub.unsubscribe();
  });
});

export const apolloClient = new ApolloClient({
  link: ApolloLink.from([authLink, errorLink, httpLink]),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          products: {
            merge: false,
          },
        },
      },
    },
  }),
});
